module.exports = __webpack_public_path__ + "media/images/card_mastercard-289a3ae36bd6e03b7b5f40cee679efbb.svg";